import React, { forwardRef } from "react";
import classNames from "classnames";

import defaultStyle from "./main.module.scss";

type PillColors =
  | "lavender"
  | "pink"
  | "ice"
  | "champagne"
  | "matcha"
  | "light"
  | "lilac"
  | "water"
  | "turmeric"
  | "lime"
  | "black"
  | "punch"
  | "light-orange"
  | "light-yellow"
  | "mist-green";

type PillsProps = {
  color: PillColors;
  children?: React.ReactNode;
  styles?: ModularStyles;
  className?: string;
  innerDot?: boolean;
  border?: boolean;
};

export const Pill = forwardRef<HTMLSpanElement, PillsProps>(
  (
    {
      color = "black",
      styles = defaultStyle,
      children = null,
      className = "",
      innerDot = false,
      border = false,
    },
    ref,
  ) => {
    const COLOR_STYLE: { [color in PillColors]: string } = {
      lavender: styles.lavenderPill,
      pink: styles.pinkPill,
      ice: styles.icePill,
      champagne: styles.champagnePill,
      matcha: styles.matchaPill,
      light: styles.lightPill,
      lilac: styles.lilacPill,
      water: styles.waterPill,
      turmeric: styles.turmericPill,
      lime: styles.limePill,
      black: styles.blackPill,
      punch: styles.punchPill,
      "light-orange": styles.lightOrangePill,
      "light-yellow": styles.lightYellowPill,
      "mist-green": styles.mistGreenPill,
    };

    const customStyle = { ...(!COLOR_STYLE[color] && { background: color }) };

    return (
      <span
        ref={ref}
        className={classNames(className, styles.pill, {
          [styles.pillBorder]: border,
          [COLOR_STYLE[color]]: !!COLOR_STYLE[color],
        })}
        style={customStyle}
      >
        {innerDot && <span className={styles.innerStatusDot} />}
        {children}
      </span>
    );
  },
);

export default Pill;
